import { Button } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../layout/header/Header'

const ErrorPage = () => {
  return (
    <>
    <Header/>
    <div className="grid h-screen place-content-center bg-white px-4">
  <div className="text-center">
    <h1 className="text-9xl font-black text-gray-200">404</h1>

    {/* <p className="text-2xl font-bold tracking-tight text-gray-900 sm:text-4xl">Uh-oh!</p> */}

    <p className="mt-4 text-gray-500">We can't find that page.</p>
 
    <Link to='/'><Button >Go Back Home</Button></Link>
  </div>
</div>
</>
  )
}

export default ErrorPage